import { styled } from '@uhg-abyss/web/tools/styled';
import { Icon } from '@uhg-abyss/web/ui/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

type AlertProps = {
  isLandingPage?: boolean;
  county: string;
  isOutOfCounty: boolean;
  isOutOfCntyIndicatorEnabled?: boolean;
};
export const CountyText = styled('span', {
  dynamic: ({ cssProps: { isLandingPage } = {} }) => ({
    '@media (max-width: 464px)': {
      minWidth: isLandingPage ? '80px' : '100px',
      maxWidth: isLandingPage ? '102px' : '200px',
    },
  }),
  maxWidth: '191px',
  color: '#C24E14',
  fontSize: '13px',
  lineHeight: '16px',
  height: 'auto',
});
export const IconContainer = styled(Icon, {
  'abyss-icon': { width: '16px', height: '16px' },
});

export const CountyAlertContainer = styled('div', {
  display: 'inline-flex',
  marginTop: '2px',
});

export const OutsideCountyAlert = ({
  isLandingPage = false,
  county,
  isOutOfCounty,
  isOutOfCntyIndicatorEnabled = false,
}: AlertProps) => {
  const { t } = useTranslation();

  return (
    <CountyAlertContainer
      css={{
        marginBottom:
          (isOutOfCntyIndicatorEnabled && !isOutOfCounty && '24px') || '0px',
      }}
    >
      {isOutOfCounty ? (
        <React.Fragment>
          <IconContainer
            color="#C24E14"
            data-auto-testid="out-of-county-icon"
            data-testid="out-of-county-icon"
            title="out-of-county"
          >
            <svg xmlns="http://www.w3.org/2000/svg">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </svg>
          </IconContainer>
          <CountyText
            aria-label={`Outside of ${county}`}
            cssProps={{ isLandingPage }}
            data-testid="out-of-county-text"
          >
            {`${t('Outside of')} `}
            {county}
          </CountyText>{' '}
        </React.Fragment>
      ) : (
        <React.Fragment />
      )}
    </CountyAlertContainer>
  );
};
